export default __webpack_public_path__ + "static/media/carina_delea.379d3f39.png";